import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  previousPage: () => void;
  nextPage: () => void;
  productItemCount: number;
  lastPage: () => void;
  firstPage: () => void;
}

// Centered First / Prev / {page}/{total} / Next / Last — matches trade.
const Pagination = ({
                      totalPages,
                      currentPage,
                      previousPage,
                      nextPage,
                      lastPage,
                      firstPage,
                    }: PaginationProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        gap: 0.5,
      }}
    >
      <IconButton size="small" onClick={() => firstPage()} sx={{ color: 'text.primary' }}>
        <FirstPageIcon fontSize="small" />
      </IconButton>

      <IconButton size="small" onClick={() => previousPage()} sx={{ color: 'text.primary' }}>
        <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
      </IconButton>

      <Typography sx={{ fontWeight: 700, fontSize: 14, mx: 1, minWidth: 'fit-content' }}>
        {currentPage}/{isNaN(totalPages) ? '1' : totalPages}
      </Typography>

      <IconButton size="small" onClick={() => nextPage()} sx={{ color: 'text.primary' }}>
        <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
      </IconButton>

      <IconButton size="small" onClick={() => lastPage()} sx={{ color: 'text.primary' }}>
        <LastPageIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default Pagination;